
const Mission = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-[#1C1C1C] mb-8">協會介紹</h2>
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              社團法人嚴前總統家淦先生紀念協會成立於民國89年10月22日，成立的目的除了紀念已故嚴前總統家淦先生對台灣在財政、經濟建設、工業科技、外交、教育上面對的卓越貢獻外，也要發揚嚴總統是台灣第一個文人總統亦是國家的三軍統帥，愛好生活、收藏文物、攝影、賞析音樂等，在台灣他先後任財政廳長、省政府主席、經濟部長、兩任財政部長、經委員主委、美援會主委、輔導會主任、九年行政院長、兩任副總統、三年總統。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              本會依法設立、非以營利為目的之社會團體。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              以弘揚嚴前總統家淦先生醫生為國為民奉獻之精神，發展財金建設，促進工商繁榮，提升中華文化素質，增進各項學術交流及維護保存文化資產，以造福邦國人民為為務宗旨。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
